import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import DonationCard from '../DonationCard/DonationCard.vue'

export default {
  name: 'HoldetsDonationer',
  props: {
    teamId: { type: String, required: false },
    donationFormUrl: { type: String, required: false }
  },
  components: { DonationCard },
  setup(props) {
    const store = useStore()

    const teamId = computed(() =>
      props.teamId ?? store.state.main.page_overlay_content_data.teamId
    )
    const donationFormUrl = computed(() =>
      props.donationFormUrl ?? store.state.main.page_overlay_content_data.donationFormUrl
    )

    const listOfDonations = computed(
      () => store.getters['stafet/teamDonationsPaginated']
    )
    const totalHits = computed(
      () => store.getters['stafet/teamDonationsPaginatedTotalHits']
    )

    const offsetDonationer = ref(0)
    const offsetAdmissions = ref(0)
    const limit = ref(50)
    const isLoadingMore = ref(false)

    const fetchDonations = async () => {
      try {
        isLoadingMore.value = true
        const { nextOffsetDonationer, nextOffsetAdmissions } =
          await store.dispatch('stafet/getTeamDonationsPaginated', {
            teamId: teamId.value,
            offsetDonationer: offsetDonationer.value,
            offsetAdmissions: offsetAdmissions.value,
            limit: limit.value
          })

        offsetDonationer.value = nextOffsetDonationer
        offsetAdmissions.value = nextOffsetAdmissions
      } catch (err) {
        console.error(err)
      } finally {
        isLoadingMore.value = false
      }
    }

    onMounted(fetchDonations)

    const loadMore = () => {
      if (!isLoadingMore.value) {
        fetchDonations()
      }
    }

    const showLoadMore = computed(() => {
      return listOfDonations.value.length < totalHits.value
    })

    return {
      donationFormUrl,
      listOfDonations,
      loadMore,
      showLoadMore,
      isLoadingMore,
      getLabel: (labelKey) =>
        store.getters['labels/getLabel']({
          labelCollection: 'HoldetsDonationer',
          labelKey
        })
    }
  }
}
